import Cookies from "js-cookie";
import Alpine from "alpinejs";

// Plugins
window.cookies = Cookies;

// Add to window
window.Alpine = Alpine;
window.Alpine.start();
